import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
 import HomeView from '../views/HomeView.vue'
import ConsoleView from '../views/ConsoleView.vue'

const routes: Array<RouteRecordRaw> = [
   {
    path: '/home',
    name: 'home',
    component: HomeView,
      meta: { requiresAuth: true }  // 商品列表不需要登录
  }
  , {
    path: '/Console',
    name: 'Console',
    component: ConsoleView,
      meta: { requiresAuth: true }  // 商品列表不需要登录
  } ,  {
    path: '/News/Products/',
    name: 'NewsProducts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Products.vue')
  } ,  {
    path: '/News/Contactus/',
    name: 'Contactus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Contactus.vue')
  } ,  {
    path: '/News/NewsList/',
    name: 'NewsList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/NewsList.vue')
  } ,  {
    path: '/News/NewsDetails/',
    name: 'NewsDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/NewsDetails.vue')
  }, {
    path: '/News/ProductsDetail/',
    name: 'ProductsDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/ProductsDetail.vue')
  } ,
   {
    path: '/News/Partner/',
    name: 'Partner',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Partner.vue')
  } ,  {
    path: '/News/Support/',
    name: 'Support',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Support.vue')
  } ,   {
    path: '/News/Solution/',
    name: 'Solution',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Solution.vue')
  } , {
    path: '/',
    name: 'NewsHome',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Home.vue')
  }
  ,  {
    path: '/Products/ProductsCategory/',
    name: 'ProductsCategory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/ProductsCategory.vue')
  },  {
    path: '/Products/Cart/',
    name: 'Cart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/Cart.vue')
  }, {
    path: '/Products/ProductsDetails/',
    name: 'ProductsDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/ProductsDetails.vue')
  },
  {
    path: '/',
    name: 'shopList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopView.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  } ,{
    path: '/shop/shoplist/:page',
    name: 'shopList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopView.vue')
  },  {
    path: '/shop/ShopCreate/:id',
    name: 'ShopCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopCreateView.vue')
  },  {
    path: '/shop/ShopDetails/',
    name: 'ShopDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopDetailsView.vue')
  },  {
    path: '/shop/ShopbusinesshoursSetting/',
    name: 'ShopbusinesshoursSetting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopbusinesshoursSetting.vue')
  }
 ,{
    path: '/Orders/OrderList',
    name: 'OrderList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Orders/OrderList.vue')
  },{
    path: '/Orders/OrderDetails',
    name: 'OrderDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Orders/OrderDetails.vue')
  }
,{
    path: '/Shop/Classificationsettings/',
    name: 'Classificationsettings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/Classificationsettings.vue')
  }
,{
    path: '/Users/PersonalCenter/',
    name: 'PersonalCenterView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Users/PersonalCenterView.vue')
  },{
    path: '/Users/Account/',
    name: 'Account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Users/Account.vue')
  }
  ,  {
    path: '/Alipay/AlipaySuccess/',
    name: 'AlipaySuccess',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Alipay/AlipaySuccess.vue')
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
